"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityLabel = exports.CommunityCategory = void 0;
var CommunityCategory;
(function (CommunityCategory) {
    CommunityCategory["emptyStateOldClubCommunity"] = "EmptyStateOldClubCommunity";
})(CommunityCategory || (exports.CommunityCategory = CommunityCategory = {}));
var CommunityLabel;
(function (CommunityLabel) {
    CommunityLabel["pageView"] = "PageView";
    CommunityLabel["buttonKnowMore"] = "ButtonKnowMore";
    CommunityLabel["buttonAccessCommunity"] = "ButtonAccessCommunity";
})(CommunityLabel || (exports.CommunityLabel = CommunityLabel = {}));
